module.exports = __webpack_public_path__ + "static/img/vertex-default.a2bdc730.png";